export const quizSections = [
  {
    id: 'christian',
    label: 'The Christian',
    title: 'Mindset & Calling',
    desc: 'How clearly are you writing from your calling rather than fear or comparison?',
    questions: [
      { id: 'q1', text: 'I write from a clear sense of calling rather than platform pressure or comparison.' },
      { id: 'q2', text: 'When fear or doubt shows up, I return to my gospel motivation rather than letting it stop my work.' },
      { id: 'q3', text: 'I regularly reflect on who I\'m writing for and why — beyond sales or recognition.' }
    ]
  },
  {
    id: 'creator',
    label: 'The Creator',
    title: 'Writing & Finishing',
    desc: 'Are you consistently putting words on the page and completing what you start?',
    questions: [
      { id: 'q4', text: 'I write consistently — not just when inspired — and make regular progress on my manuscript.' },
      { id: 'q5', text: 'I finish what I start. Drafts in my life become completed manuscripts.' },
      { id: 'q6', text: 'I invest in my craft through courses, feedback, or deliberate practice.' }
    ]
  },
  {
    id: 'caretaker',
    label: 'The Caretaker',
    title: 'Editing & Publishing',
    desc: 'Are your finished drafts becoming published books — or sitting unedited on your hard drive?',
    questions: [
      { id: 'q7', text: 'I take my finished drafts through a real editing process before publishing.' },
      { id: 'q8', text: 'I have a clear publishing plan for my work — or I\'m actively building one.' },
      { id: 'q9', text: 'I treat my author work as a stewardship worth managing, not just a creative outlet.' }
    ]
  },
  {
    id: 'connector',
    label: 'The Connector',
    title: 'Marketing & Reaching Readers',
    desc: 'Are you deliberately connecting your book to the readers who need it?',
    questions: [
      { id: 'q10', text: 'I regularly tell people about my book through email, social media, ads, or other channels.' },
      { id: 'q11', text: 'I have a consistent way of reaching new readers — not just waiting for them to find me.' },
      { id: 'q12', text: 'I think of marketing as serving my reader, not self-promotion.' }
    ]
  }
];

export const personaDetails = {
  christian: {
    name: 'The Christian',
    affirmation: 'Your foundational motivation is strong. You are clearly writing from a deep sense of calling rather than seeking worldly validation.',
    gap: 'You might be struggling with comparison or losing sight of your primary "why". Take time this week to write down your core gospel motivation for your current project.',
    offerName: 'GospelWise Author Handbook',
    offerLink: 'https://gospelwiseauthor.com/shop'
  },
  creator: {
    name: 'The Creator',
    affirmation: 'You are a master of making time for your craft. Your dedication to consistently putting words on the page is bearing fruit.',
    gap: 'You have a tendency to start projects but struggle to see them through to completion. Commit to a realistic, daily word count goal for the next 14 days and stick to it.',
    offerName: 'One Draft Wonder or FaiBoWriMo',
    offerLink: 'https://gospelwiseauthor.com/shop'
  },
  caretaker: {
    name: 'The Caretaker',
    affirmation: 'You treat your work with the respect it deserves. Your commitment to editing and professional publishing sets your books apart.',
    gap: 'Your drafts might be piling up without receiving the polish they need to be truly impactful. Schedule a dedicated block of time next week solely for editing your most complete manuscript.',
    offerName: 'Write. Refine. Release. Cohort',
    offerLink: 'https://gospelwiseauthor.com/shop'
  },
  connector: {
    name: 'The Connector',
    affirmation: 'You understand that marketing is a form of service. You are effectively bridging the gap between your message and the readers who need it.',
    gap: 'You are writing great content but hesitating to share it with the world. Choose one channel (email or social media) and share a brief, honest update about your book this week.',
    offerName: 'GospelWise Author Marketing Essentials',
    offerLink: 'https://gospelwiseauthor.com/shop'
  }
};